module.exports = __webpack_public_path__ + "5861e33d8d61f8211993a8a5c66ad9a3.pdf";